import React from "react";

const IconeCartaoCredito = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    shapeRendering="geometricPrecision"
  >
    <rect width="24" height="24" rx="6" fill="#1e293b" />
    <rect x="3" y="7" width="18" height="11" rx="2.5" fill="#334155" stroke="#475569" strokeWidth="0.5" />
    <rect x="3" y="10" width="18" height="2.5" fill="#0f172a" opacity="0.85" />
    <rect x="5.5" y="14.5" width="5" height="1.5" rx="0.75" fill="#cbd5e1" />
    <rect x="14.5" y="13.5" width="4.5" height="3.5" rx="1" fill="#f59e0b" />
    <rect x="15" y="14.25" width="3.5" height="2" rx="0.5" fill="#fbbf24" opacity="0.55" />
  </svg>
);

export default IconeCartaoCredito;
